
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/board-member/[uid]",
      function () {
        return require("private-next-pages/board-member/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/board-member/[uid]"])
      });
    }
  